// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'Ai-Music-Admin',
  storageUserDataKeyName: 'Ai-Music-Admin',
}
